import React, { createContext, useCallback, useContext, useState } from 'react';

interface WidgetEventState {
  lendiPending: boolean;
  setLendiPending: (v: boolean) => void;
  consumeLendiPending: () => void;
}

const WidgetEventCtx = createContext<WidgetEventState | null>(null);

export const WidgetEventProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lendiPending, setLendiPending] = useState(false);
  const consumeLendiPending = useCallback(() => setLendiPending(false), []);

  return (
    <WidgetEventCtx.Provider value={{ lendiPending, setLendiPending, consumeLendiPending }}>
      {children}
    </WidgetEventCtx.Provider>
  );
};

export const useWidgetEvent = (): WidgetEventState => {
  const ctx = useContext(WidgetEventCtx);
  if (!ctx) throw new Error('useWidgetEvent must be used within WidgetEventProvider');
  return ctx;
};
